import { render, staticRenderFns } from "./DraftedForms.vue?vue&type=template&id=3e3f0e2e"
import script from "./DraftedForms.vue?vue&type=script&lang=js"
export * from "./DraftedForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports